import { useAppDispatch, useAppSelector } from "@/lib/store";
import { useEffect } from "react";
import { useDebounce } from "@/hooks/useDebounce";
import { fetchDailyWorkForVendor, setPage, setPageSize, setSearch, setSortKey, setStatus } from "./daily-work.slice";

export const useDailyWorkForVendor = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((s) => s.dailyWork);
  const debouncedSearch = useDebounce(state.filters.search, 400);

  useEffect(() => {
    const req = dispatch(fetchDailyWorkForVendor());
    return () => req.abort();
  }, [
    dispatch,
    state.filters.status,
    debouncedSearch,
    state.filters.sortKey,
    state.filters.sortOrder,
    state.pagination.page,
    state.pagination.pageSize,
  ]);

  return {
    list: state.list,
    total: state.total,
    loading: state.loading,

    filters: {
      ...state.filters,
      setStatus: (v: string) => dispatch(setStatus(v)),
      setSearch: (v: string) => dispatch(setSearch(v)),
      setSortKey: (k: string) => dispatch(setSortKey(k)),
    },

    pagination: {
      ...state.pagination,
      setPage: (p: number) => dispatch(setPage(p)),
      setPageSize: (ps: number) => dispatch(setPageSize(ps)),
    },

    refetch: () => {
      dispatch(fetchDailyWorkForVendor());
    },

    dispatch,
  };
};
